import { useRef, useEffect } from 'react';

const useInterval = (callback: Function, delay?: number | null) => {
    const savedCallback = useRef<Function>();
    const stopCallback = useRef<Function>();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const tick = () => {
            if (savedCallback.current) {
                savedCallback.current(stopCallback.current);
            }
        };

        if (delay) {
            const interval = setInterval(tick, delay);
            stopCallback.current = () => clearInterval(interval);
            return () => clearInterval(interval);
        }
    }, [delay]);
};

export default useInterval;
